<script setup lang="ts">
import type { LimitExceedData, BannerType } from '@/types';
import { useBanners } from '@/composables/useBanners';
import { computed, watch, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import ExceedModal from '../../ExceedModal.vue';
const router = useRouter();
const emit = defineEmits(['update:visible']);
const props = defineProps<{
    data: LimitExceedData;
    visible: boolean;
}>();
const bannerType: BannerType = 'responsible_gaming';
const { banners, loadingFlag: bannersLoadingFlag, toSetRequest } = useBanners(bannerType);
const { data, visible } = toRefs(props);
const currentImage = computed(() => {
    if (banners.value) {
        return banners?.value.find((banner) => banner.name === data.value.image)?.image || null;
    }
    return null;
});
watch(
    () => visible.value,
    (newValue) => {
        if (newValue && !banners.value) {
            toSetRequest(bannerType);
        }
    },
    { immediate: true }
);
function toCloseModal() {
    emit('update:visible', false);
}
function toCloseGame() {
    toCloseModal();
    router.push('/');
}
function toRedirectToSettings() {
    router.push('/profile/general/limits');
    toCloseModal();
}
</script>
<template>
    <ExceedModal :visible="visible" @update:visible="(val: boolean) => emit('update:visible', val)" @redirectToSettings="toRedirectToSettings" :currentImage="currentImage" :loading="bannersLoadingFlag">
        <template #title>{{ `${$t(data.title)}` }}</template>
        <template #amount>{{ `${data.limit_amount} ${data.player.currency}` }}</template>
        <template #buttons>
            <Button :label="$t(data.close_button_text)" fluid @click="data.is_close_game ? toCloseGame() : toCloseModal()" text class="!border !border-green-400 !p-2 !font-bold uppercase !text-green-400 hover:!bg-green-400/20"></Button>
        </template>
    </ExceedModal>
</template>
